import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSubscriptionAssessmentMutation, deleteSubscriptionAssessmentMutationVariables } from '../generated/deleteSubscriptionAssessmentMutation';
import { subscriptionAssessmentFieldsFragment } from '../models/SubscriptionAssessment';

/**
 * Get a callback to delete a SubscriptionAssessment in the store.
 */
export function useDeleteSubscriptionAssessmentCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSubscriptionAssessmentMutation, deleteSubscriptionAssessmentMutationVariables>(
        gql`
            mutation deleteSubscriptionAssessmentMutation ($id: ID!) {
                deleteSubscriptionAssessment(id: $id) {
                    ...subscriptionAssessmentFields
                }
            }

            ${subscriptionAssessmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
